<template>
  <div class="container">
    <van-nav-bar title="新增表具" left-text="" right-text="完成" @click-right="addMeter" left-arrow @click-left="onClickLeft"></van-nav-bar>
    
    <div class="listbox">
      <van-row>
        <van-col span="5" class="texr">抄表项目：</van-col>
        <van-col span="18" offset="1" class="pd10">{{communityName}}</van-col>
      </van-row>

      <van-row>
        <van-col span="5" class="texr">抄表时间：</van-col>
        <van-col span="5" offset="1" class="texl">
          <van-dropdown-menu active-color="#1989fa" class="fl_left" > 
            <van-dropdown-item v-model="addForm.monthLength" @change="initWriteNoDay" :options="option" :disabled="disabled" />
          </van-dropdown-menu>
        </van-col>
        <van-col span="1" class="texc">
          <span>第</span>
        </van-col>
        <van-col span="11" class="texc">
          <van-stepper v-model="addForm.writeNoDay" :min="1" :max="addForm.monthLength*30" step="1" :disabled="disabled" />
          <span class="pd10">天</span>
        </van-col>
      </van-row>

      <van-row>
        <van-col span="5" class="texr">抄表提醒：</van-col>
        <van-col span="5" offset="1" class="pd10">提前</van-col>
        <van-col span="1"></van-col>
        <van-col span="11" class="texc">
          <van-stepper v-model="addForm.remindBeforeDay" :min="1"  :max="30" step="1" :disabled="disabled" />
          <span class="pd10">天</span>
        </van-col>
      </van-row>
      
      <van-row>
        <van-col span="5" class="texr">每天：</van-col>
        <van-col span="5" offset="1" class="pd10">提醒</van-col>
        <van-col span="1"></van-col>
        <van-col span="11" class="texc">
          <van-stepper v-model="addForm.remindCount" :min="1"  :max="24" step="1" :disabled="disabled" />
          <span class="pd10">次</span>
        </van-col>
      </van-row>

      <div v-for="(item, index) in addForm.meterNumList" :key="index">
        <van-field v-model="item.meterNum" center label="电表编号：" placeholder="请输入电表上的编号" >
          <template #button>
            <van-button class="mg10" icon="plus" plain size="small" type="info" @click="addPower()" v-if="index == addForm.meterNumList.length - 1 && index < 30">加</van-button>
            <van-button icon="minus" plain size="small" type="danger" @click="delPower(index)" v-if="index == addForm.meterNumList.length - 1 && index > 0">减</van-button>
          </template>
        </van-field>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Button,DropdownItem,DropdownMenu,Col,Row,Stepper,Field} from 'vant';
  export default {
    data() {
      return {
        disabled: true,
        meterList:[],
        communityName: '',
        addForm: {
          communityId: '',
          monthLength: 3,
          writeNoDay: 1,
          remindBeforeDay: 5,
          remindCount: 1,
          meterNumList:[
            {meterNum:''},
            {meterNum:''},
          ]
        },
        option: [
          { text: '每月', value: 1 },
          { text: '每季度', value: 3 },
          { text: '每半年', value: 6 },
          { text: '每年', value: 12 },
        ],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Button.name]:Button,
      [DropdownItem.name]:DropdownItem,
      [DropdownMenu.name]:DropdownMenu,
      [Col.name]:Col,
      [Row.name]:Row,
      [Stepper.name]:Stepper,
      [Field.name]:Field,
    },
    methods: {
      changePage(id){
        this.$router.push({path: "chargeDetail.html",query:{orderId:id}})
      },
      addPower() {
        this.addForm.meterNumList.push({
          meterNum: ''
        });
      },
      delPower(index) {
        this.addForm.meterNumList.splice(index, 1);
      },
      initWriteNoDay(){
        this.addForm.writeNoDay = 1;
      },
      addMeter() {
        if(!this.addForm.monthLength) {
          Toast("请选择抄表时间");
          return;
        }else if(!this.addForm.writeNoDay) {
          Toast("请选择第几天");
          return;
        }else if(!this.addForm.remindBeforeDay) {
          Toast("请选择提前几天");
          return;
        }else if(!this.addForm.remindCount) {
          Toast("请选择每天提醒次数");
          return;
        }
        var flag = 0;
        this.addForm.meterNumList.forEach((item) => {
          if (!item.meterNum) {
            flag = 1;
            return;
          }
        });
        if (flag == 1) {
          Toast("请输入电表编号");
          return;
        }
        axios.post("/meteruploaddegree/create",{...this.addForm}).then((res)=>{
          if(res.isSuccess){
            this.$router.replace({path: 'uploadDegree.html',query:{communityId:this.addForm.communityId}})
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        // this.$router.push({path: "search.html",query:{pageType: 3}});
      },
    },
    computed:{
    },
    created () {
      this.addForm.communityId = this.$route.query.communityId;
      this.communityName = this.$route.query.communityName;
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  
  .listbox{
    width: 100%;
    color: #373737;
    background: #fff;
    margin-top: 12px;
    padding-bottom: 20px;
    .van-col{
      font-size: 14px;
      height: 50px;
      line-height: 50px;
    }
    .van-stepper{
      display: inline-block;
      vertical-align: middle;
    }
  }
  .texl{text-align: left !important;}
  .texc{text-align: center !important;}
  .texr{text-align: right !important;}
  .mg10{margin:  0 10px;}
  .pd10{padding: 0 8px;}
  /deep/.van-dropdown-menu__bar{box-shadow: none;}
</style>
